export default "/assets/site/images/horgasz.jpg?dba82e8fa953c8c2803d5d11c305b7b6";